import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type VenueFooterShellProps = {
  children: ReactNode;
  className?: string;
  /**
   * `floating` is the phone's bar pinned over the bottom of the screen.
   * `inline` is the same bar as a plain card, for the desktop layouts that
   * carry the action in a sticky column instead (see DETAIL_DESKTOP).
   */
  variant?: "floating" | "inline";
};

export function VenueFooterShell({
  children,
  className,
  variant = "floating",
}: VenueFooterShellProps) {
  const bar = (
    <div
      className={cn(
        "relative overflow-hidden rounded-[22px] border border-border bg-surface px-3 py-2 dark:border-white/[0.1] dark:bg-[#101319]",
        variant === "floating" ? "shadow-2xl" : "p-3 shadow-sm",
        className,
      )}
    >
      <div className="relative flex items-center justify-between gap-3">
        {children}
      </div>
    </div>
  );

  if (variant === "inline") return bar;

  return (
    // `wide:hidden`: the server renders this before it knows the width, and a
    // desktop mounts the inline card instead once it does.
    <div className="fixed bottom-4 left-1/2 z-50 w-full max-w-2xl -translate-x-1/2 px-3 wide:hidden">
      {bar}
    </div>
  );
}
